import { Button, ButtonProps } from '@mui/material';
import { ChangeEvent, EventHandler, FC, useState } from 'react';
import { take } from 'rxjs';
import { IUploadFileCommon, uploadFilesToS3, useFileSizeGuard } from '../fileUpload.component';

export const UploadButton: FC<IButton> = ({
  accept = '*',
  multiple = false,
  place,
  maxFileSize,
  variant = 'contained',
  color = 'primary',
  text = '',
  component = 'label',
  onLoading,
  onUploaded,
  ...rest
}) => {
  const [inputKey, setInputKey] = useState<number>(0);
  const isSizeAllowed = useFileSizeGuard(maxFileSize);
  const handleFileUpload: EventHandler<ChangeEvent<HTMLInputElement>> = (evt) => {
    evt.stopPropagation();

    const files = evt.currentTarget.files;
    if (!isSizeAllowed(files)) {
      // Remount input so the user can pick again, including the same file after shrinking it
      setInputKey((prev) => prev + 1);
      return;
    }
    if (typeof onLoading === 'function' && files?.length !== 0) {
      onLoading();
    }
    uploadFilesToS3({ files, place })
      .pipe(take(1))
      .subscribe((result) => {
        if (typeof onUploaded === 'function') {
          onUploaded(result);
        }
      });
    // Remount input to clear selected files and allow uploading the same file again
    setInputKey((prev) => prev + 1);
  };
  return (
    <Button variant={variant} color={color} {...rest} component={component}>
      {text}
      <input
        key={inputKey}
        type='file'
        hidden
        accept={accept}
        multiple={multiple}
        onChange={handleFileUpload}
      />
    </Button>
  );
};
interface IButton extends IUploadFileCommon, ButtonProps {
  text: string;
}
